module.exports = __webpack_public_path__ + "img/login-bg.f4cef2c7.png";